export const cxBase = '/cx/v1';
export const coreBase = '/core/v1';

export const cxBaseV2 = '/cx/v2';
export const coreBaseV2 = '/core/v2';

export const cxBaseV3 = '/v3';

export const dataV4 = '/data/v4';
